import Vue from 'vue';
import {Model} from '@vuex-orm/core';
import store from '$src/store';
import moment from "moment";

export default class Event extends Model {

    static entity = 'event';
    static primaryKey = 'id_event';

    static fields() {
        return {
            id_event: this.number(null),
            title: this.string(''),
            description: this.string(''),
            status: this.number(0),
            id_image: this.attr(null),
            location: this.attr(''),
            address: this.attr({
                street: '',
                street_number: '',
                post_code: '',
                city: '',
                country: null,
            }),
            register_open: this.boolean(false),
            register_application: this.boolean(false),
            register_possible: this.number(0),
            queue_available: this.boolean(false),
            queue_auto_update: this.boolean(false),
            notification: this.boolean(true),
            email_admin: this.boolean(true),
            mandatory: this.boolean(false),
            allow_parallel: this.boolean(true),
            allow_export_apology: this.boolean(false),
            child_multiple: this.boolean(true),
            member_limit: this.number(0),
            country_state: this.attr(null),
            event_start: this.attr(null),
            event_end: this.attr(null),
            register_start: this.attr(null),
            register_end: this.attr(null),
            parent: this.attr(null),
            parent_seminar: this.attr(null),
            parent_event: this.attr(null),
            children: this.attr(null),
            _entityAuth: this.attr({}),
            user_count: this.attr(null),
            invited_at: this.attr(null),
            blocking_event: this.attr(null),
            attachments: this.attr([]),
            discharge_applications: this.attr([]),
            user_discharge_applied: this.boolean(false),
        };
    }

    static roleName = {
        discharged: 0,
        applicant: 1,
        invited: 2,
        waiting: 3,
        member: 4,
        admin: 5,
        discharge_applicant: 6,
    };

    static registerMode = {
        disallow: 0,
        apply: 1,
        join: 2,
    };

    get link() {
        return {route: 'community_event', params: {id_event: this.id_event}};
    }

    get linkEdit() {
        return {route: 'community_event_edit', params: {id_event: this.id_event}};
    }

    get linkCreateSub() {
        return {route: 'community_event_edit', params: {id_event: 'new', id_parent: this.id_event}};
    }

    get image() {
        return Vue.$img(this.id_image, '/img/event.jpg');
    }

    get roles() {
        if (this.role_ids && this.role_ids.length > 0) {
            return this.role_ids.split(',').map(id_role => store.getters['auth/getRoleById'](id_role));
        }
        return [];
    }

    get rolesString() {
        return this.roles.map(role => role.label).join(', ');
    }

    hasRole(name) {
        return !!this.roles.find(role => role.name === name);
    }

    static make() {
        return Object.entries(this.fields()).reduce((result, [name, field]) => {
            result[name] = field.value;
            return result;
        }, {});
    }

    inRegistrationTime() {
        let date = new Date();

        if (this.register_start === null && this.register_end === null) {
            return true;
        }

        return moment(this.register_start).isSameOrBefore(date)
            && moment(this.register_end).isSameOrAfter(date);
    }

    static dateStringFormat(event, withTime = false) {
        let eventStart = moment(event.event_start);
        let eventEnd = moment(event.event_end);
        let singleDay = eventStart.isSame(eventEnd, 'date');

        let result = eventStart.format("YYYY") === eventEnd.format("YYYY") ? eventStart.format("DD. MMMM") : eventStart.format("DD. MMMM YYYY");
        if (withTime) {
            result += ` ${moment(event.event_start).format("HH:mm")} Uhr`;
            if (singleDay) {
                result += ` - ${moment(event.event_end).format("HH:mm")} Uhr`;
            }
        }
        if (!singleDay) {
            result += " - " + eventEnd.format("DD. MMMM YYYY");
            if (withTime) {
            result += ` ${moment(event.event_end).format("HH:mm")} Uhr`;
        }
        }
        return result;
    }

    get countryStateString() {
        return Vue.__(`country_state/${this.country_state}`);
    }
}